import pythonApiClient from "./pythonBaseApi";

const metodosPagoApi = {
  /**
   * Obtener todos los métodos de pago
   * @param {boolean} activo - Filtrar solo métodos activos
   * @returns {Promise} Lista de métodos de pago
   */
  getMetodosPago: (activo = true) => {
    return pythonApiClient.get("/corporativo/metodos-pago", {
      params: { activo },
    });
  },

  /**
   * Obtener método de pago por ID
   * @param {number} metodoPagoId - ID del método de pago
   * @returns {Promise} Datos del método de pago
   */
  getMetodoPagoById: (metodoPagoId) => {
    return pythonApiClient.get(`/corporativo/metodos-pago/${metodoPagoId}`);
  },

  /**
   * Crear nuevo método de pago
   * @param {Object} metodoPagoData - Datos del método de pago
   * @returns {Promise} Método de pago creado
   */
  createMetodoPago: (metodoPagoData) => {
    return pythonApiClient.post("/corporativo/metodos-pago", metodoPagoData);
  },

  /**
   * Actualizar método de pago
   * @param {number} metodoPagoId - ID del método de pago
   * @param {Object} metodoPagoData - Datos a actualizar
   * @returns {Promise} Método de pago actualizado
   */
  updateMetodoPago: (metodoPagoId, metodoPagoData) => {
    return pythonApiClient.put(`/corporativo/metodos-pago/${metodoPagoId}`, metodoPagoData);
  },

  /**
   * Eliminar método de pago
   * @param {number} metodoPagoId - ID del método de pago
   * @returns {Promise} Resultado de la eliminación
   */
  deleteMetodoPago: (metodoPagoId) => {
    return pythonApiClient.delete(`/corporativo/metodos-pago/${metodoPagoId}`);
  },
};

export default metodosPagoApi;
